import type { OptionKV } from "~styled/selector/Selector";

export enum ECompania {
  Sancor = "Sancor",
  Berkley = "Berkley",
  Zurich = "Zurich",
  Triunfo = "Triunfo",
  RUS = "RUS",
  MercantilAndina = "MercantilAndina",
}

const TODOS = "";
export const SANCOR = ECompania.Sancor;
export const BERKLEY = ECompania.Berkley;
export const ZURICH = ECompania.Zurich;
export const TRIUNFO = ECompania.Triunfo;
export const RUS = ECompania.RUS;
export const MERCANTIL_ANDINA = ECompania.MercantilAndina;

const companiasSegurosOptions: Record<ECompania | typeof TODOS, string> = {
  [TODOS]: "Todos",
  [SANCOR]: "Sancor",
  [BERKLEY]: "Berkley",
  [ZURICH]: "Zurich",
  [TRIUNFO]: "Triunfo",
  [RUS]: "Río Uruguay Seguros",
  [MERCANTIL_ANDINA]: "Mercantil Andina",
};

const companiasFilter: OptionKV<ECompania | typeof TODOS>[] = [
  { label: companiasSegurosOptions[TODOS], value: TODOS },
  { label: companiasSegurosOptions[SANCOR], value: SANCOR },
  { label: companiasSegurosOptions[BERKLEY], value: BERKLEY },
  { label: companiasSegurosOptions[ZURICH], value: ZURICH },
  { label: companiasSegurosOptions[TRIUNFO], value: TRIUNFO },
  { label: companiasSegurosOptions[RUS], value: RUS },
  { label: companiasSegurosOptions[MERCANTIL_ANDINA], value: MERCANTIL_ANDINA },
];

export { companiasSegurosOptions, companiasFilter };
